<div class="flex flex-col h-full gap-4">
  <!-- Toolbar -->
  @if (searchable()) {
    <div class="flex flex-row items-center justify-between">
      <div class="relative w-full max-w-sm">
        <div
          class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-muted-foreground"
        >
          <ng-icon name="lucideSearch" class="w-4 h-4"></ng-icon>
        </div>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          placeholder="Buscar..."
          class="flex h-10 w-full rounded-md border border-border bg-background px-3 py-2 pl-10 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
    </div>
  }

  <!-- Table -->
  <div
    class="grow h-full flex items-start overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200 rounded-lg border bg-card text-card-foreground shadow-xs"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b border-border bg-muted/40">
          @if (selectable()) {
            <th
              class="w-12 py-3 px-4 text-center align-middle border-r border-border/50"
            >
              <input
                type="checkbox"
                class="h-4 w-4 rounded border-border text-primary focus:ring-primary focus:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                [checked]="isAllSelected"
                [indeterminate]="isIndeterminate"
                (change)="toggleAllSelection($event)"
              />
            </th>
          }
          @for (col of columns(); track col.key) {
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium whitespace-nowrap border-r border-border/50 last:border-r-0 transition-colors cursor-default hover:bg-accent hover:text-foreground select-none"
              [ngClass]="col.widthClass || ''"
              [class.cursor-pointer]="col.sortable"
              (click)="handleSort(col)"
            >
              <div class="flex flex-row items-center justify-between gap-2">
                <span
                  class="w-full inline-block"
                  [class.text-center]="col.align === 'center'"
                  [class.text-right]="col.align === 'right'"
                  [innerHTML]="col.label"
                >
                </span>
                @if (col.sortable) {
                  <div class="flex flex-col items-center ml-2">
                    @if (sortState()?.column === col.key) {
                      @if (sortState()?.direction === "asc") {
                        <ng-icon
                          name="lucideChevronUp"
                          class="w-4 h-4 text-primary"
                        ></ng-icon>
                      } @else {
                        <ng-icon
                          name="lucideChevronDown"
                          class="w-4 h-4 text-primary"
                        ></ng-icon>
                      }
                    } @else {
                      <ng-icon
                        name="lucideChevronsUpDown"
                        class="w-4 h-4 opacity-30"
                      ></ng-icon>
                    }
                  </div>
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (processedData().length === 0) {
          <tr>
            <td
              [attr.colspan]="columns().length + (selectable() ? 1 : 0)"
              class="h-24 text-center text-muted-foreground border-b border-border/50"
            >
              No se encontraron resultados.
            </td>
          </tr>
        } @else {
          @for (row of processedData(); track $index) {
            <tr
              class="border-b border-border hover:bg-accent hover:text-accent-foreground transition-colors group"
              [class.cursor-pointer]="clickableRows()"
              (click)="onRowClick(row)"
            >
              @if (selectable()) {
                <td
                  class="py-4 px-4 text-center align-middle border-r border-border/50"
                >
                  <input
                    type="checkbox"
                    class="h-4 w-4 rounded border-border text-primary focus:ring-primary focus:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                    [checked]="isSelected(row)"
                    (change)="toggleSelection(row, $event)"
                  />
                </td>
              }
              @for (col of columns(); track col.key) {
                <td
                  class="py-4 px-4 whitespace-nowrap text-foreground group-hover:text-foreground"
                  [ngClass]="col.widthClass || ''"
                  [class.text-center]="col.align === 'center'"
                  [class.text-right]="col.align === 'right'"
                >
                  @if (col.type === "custom" && cellTemplate()) {
                    <ng-container
                      *ngTemplateOutlet="
                        cellTemplate()!;
                        context: { row: row, col: col }
                      "
                    ></ng-container>
                  } @else {
                    {{ getValue(row, col) }}
                  }
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
